import { render, staticRenderFns } from "./menuLayout.vue?vue&type=template&id=5e86c3f8&scoped=true"
import script from "./menuLayout.vue?vue&type=script&lang=js"
export * from "./menuLayout.vue?vue&type=script&lang=js"
import style0 from "./menuLayout.vue?vue&type=style&index=0&id=5e86c3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e86c3f8",
  null
  
)

export default component.exports